module.exports = __webpack_public_path__ + "img/chinesecompany163.aed422ee.png";